module.exports = __webpack_public_path__ + "img/whatsapp-brands.09762df5.svg";